export function expandCamelCase(line: string) {
  let result: string = '';
  for (let i = 0; i < line.length; i++) {
    let char = line.charAt(i);
    if (i > 0 && (/[A-Z]/.test(char))) result += " ";
    result += char;
  }
  return result;
}
